import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { track } from '@utils';
import { getAlertInsights } from '@api/autoInsights';
import { AUTO_INSIGHTS_ALERT_CLICK } from '@src/utils/sensor/track';
import { SettingTypes } from '../Settings';
import useAiAlertStore from '@globalStore/aiAlertStore';

const { baseUrl } = window.conviva;

const drawerEvent: any = new CustomEvent('auto-insights-drawer', {
  detail: { visible: false },
});

function useFetchSummary({ to, limit = 500 }) {
  return useQuery(
    [SettingTypes.alertInsights, to, limit],
    () =>
      getAlertInsights({
        params: {
          to,
          limit,
        },
      }),
    {
      // default cacheTime is 5 minutes
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}

const getFilterName = (values) => values.map(({ cause }) => cause).join(' | ');

function useSearchSummary({ interval, closeMore }) {
  const { start_ms, end_ms } = interval;
  const navigate = useNavigate();

  const { setAutoInsightsFilter, setInterval } = useAiAlertStore((state) => ({
    setAutoInsightsFilter: state.setAutoInsightsFilter,
    setInterval: state.setInterval,
  }));

  return (alert) => {
    const { values, alertIds } = alert;
    // for vertical ai alerts layout
    setAutoInsightsFilter({
      name: getFilterName(values),
      alertIds,
    });
    setInterval({
      from: moment(start_ms).format(),
      to: moment(end_ms).format(),
      shortcut: 'custom',
    });

    navigate(`${baseUrl}/dashboard/ai-alerts`);
    document.dispatchEvent(drawerEvent); // close main drawer
    closeMore(); // close more drawer
    track({ event: AUTO_INSIGHTS_ALERT_CLICK });
  };
}

export { drawerEvent, useFetchSummary, useSearchSummary };
